/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withUAPLThemedStyles } from '../with-themed-styles';

import { getVideoPlacementStyles } from '../styles/ad-placement-components/video-placement-styles';
import type { UAPPlacementComponentProps, UAPVideo } from '../@types';


export const VideoPlacementInner = ({
  classes,
  videos,
}: UAPPlacementComponentProps) => {
  const {
    src,
    height,
    width,
  }: UAPVideo = videos && videos.length > 0 ? videos[0] : {};

  const videoRef = useRef<HTMLVideoElement>(null);

  // check for vertical video
  const isVerticalVideo = useMemo(() => height > width, [height, width]);
  const videoPlayerRootClass = isVerticalVideo ? classes.videoPlayerVertical : classes.videoPlayerRoot;

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [src]);

  return (
    <div className={classNames(classes.placementCard, 'ad-placement-card-preview')}>
      <div className={videoPlayerRootClass}>
        <video controls style={{ height: '100%', width: '100%', borderRadius: '10px' }} ref={videoRef}>
          <source src={src} />
          <track
            kind="captions"
            src=""
            srcLang="en"
            label="English"
            default
          />
        </video>
      </div>
    </div>
  );
};

VideoPlacementInner.propTypes = {
  classes: PropTypes.shape({
    videoPlayerRoot: PropTypes.string,
  }),
  videos: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
  })),
};

VideoPlacementInner.defaultProps = {
  classes: {},
  videos: null,
};

export const VideoPlacement = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => <VideoPlacementInner {...props} />,
  getVideoPlacementStyles,
  { componentName: 'VideoPlacement' }
);
